import { useCallback, useEffect, useRef, useState } from "react";
import { EMetaStatus, IPlanoGovernoEixoForm, IPlanoGovernoEixoMeta, IPlanoGovernoMetaCreate, IPlanoGovernoMetaDetalhes, IPlanoGovernoMetaForm, IPlanoGovernoMetaUpdate } from "../../../interfaces";
import { Form, InputNumberProps, notification } from "antd";
import PlanoGovernoService from "../../../../../services/http/services/PlanoGovernoService";
import toast from "../../../../../utils/toast";
import { EmitError } from "../../../../../utils/EmitError";
import dayjs from "dayjs";
import { antdConvertDataSave, validaDigitaçãoEFormataDinheiroBR } from "../../../../../utils/Conversores";

export default function useMeta(isModalOpen: boolean, metaUuid: string | undefined, handleCancel: () => void, eixoUUid: string) {

    const [isLoadingModal, setIsLoadingModal] = useState<boolean>(false);
    const [prioridadeSelecionada, setPrioridadeSelecionada] = useState<string>("Normal");
    const [statusSelecionado, setStatusSelecionado] = useState<EMetaStatus>(EMetaStatus.PENDENTE);
    const [inputSliderValue, setInputSliderValue] = useState(0);

    const controller = new AbortController();
    const [formMeta] = Form.useForm();
    const refFormMeta = useRef<any>(null);

    const [visibleDatePicker, onVisibleDatePicker] = useState(false);
    const [defaultValueDatePicker, onDefaultValueDatePicker] = useState<Date>();


    const handleSetPrioridade = useCallback((prioridade: string) => {
        setPrioridadeSelecionada(prioridade);
        formMeta.setFieldsValue({ prioridade });
    }, []);


    const handleSetStatus = useCallback((statusMeta: EMetaStatus) => {
        setStatusSelecionado(statusMeta);
        let valueSlider = 0;

        if (statusMeta === EMetaStatus.EM_ANDAMENTO) {
            valueSlider = 20;
        }

        if (statusMeta === EMetaStatus.EM_REANALISE) {
            valueSlider = 50;
        }

        if (statusMeta === EMetaStatus.CANCELADO) {
            valueSlider = 10;
        }

        if (statusMeta === EMetaStatus.CONCLUIDO) {
            valueSlider = 100;
        }


        setInputSliderValue(valueSlider);
        formMeta.setFieldsValue({ porcentagemConclusao: valueSlider });
        formMeta.setFieldsValue({ status: statusMeta });
    }, []);

    const onChangeSliderValue: InputNumberProps['onChange'] = (newValue) => {
        setInputSliderValue(newValue as number);
        formMeta.setFieldsValue({ porcentagemConclusao: newValue });
    };

    const onClickSalvarMeta = useCallback((): void => {

        refFormMeta.current
            .validateFields()
            .then((values: IPlanoGovernoMetaForm) => {
                // id ibge de cianorte
                values.eixoUuid = eixoUUid;

                // values.dataPrevistaConclusao = antdConvertDataSave(values.dataPrevistaConclusao, true)
                if (values?.dataPrevistaConclusao) {
                    values.dataPrevistaConclusao = dayjs(values.dataPrevistaConclusao).toDate();
                }
                // values.dataPrevistaConclusao = values.dataPrevistaConclusao ? new Date(values.dataPrevistaConclusao) : undefined;
                values.valorEstimado = values.valorEstimado ? values.valorEstimado.replace(/\D/g, '') : undefined;
                values.valorGasto = values.valorGasto ? values.valorGasto.replace(/\D/g, '') : undefined;
                if (values.uuid) {
                    values.objetivo = values.objetivo ?? undefined;
                    values.responsavel = values.responsavel ?? undefined;
                    values.impactoSocial = values.impactoSocial ?? undefined;
                    values.observacoes = values.observacoes ?? undefined;
                    handleUpdateMeta(values.uuid, values)

                    return;
                }
                handleCreateMeta(values);
            })
            .catch((errorInfo: any) => {
                notification.error({
                    message: "Erro",
                    description: "Preencha os campos obrigatorios!",
                });
            });
    }, [eixoUUid]);

    const handleCreateMeta = useCallback(async (meta: IPlanoGovernoMetaCreate) => {
        try {
            setIsLoadingModal(true);
            const createdMeta = await PlanoGovernoService.createMeta(meta);

            if (createdMeta) {

                toast({
                    type: 'success',
                    text: 'Meta salva com sucesso!',
                    duration: 5000,
                });
                // setMeta(createdMeta);

                // formMeta.setFieldsValue({
                //     ...createdMeta,
                // });
                handleCancel();
            }
            setIsLoadingModal(false);
        } catch (err: any) {
            EmitError(err, true);
            setIsLoadingModal(false);
        }
    }, []);

    const handleUpdateMeta = useCallback(async (uuid: string, meta: IPlanoGovernoMetaUpdate) => {
        try {

            setIsLoadingModal(true);
            const updatedMeta = await PlanoGovernoService.updateMeta(uuid, meta);

            if (updatedMeta) {

                toast({
                    type: 'success',
                    text: 'Meta atualizada com sucesso!',
                    duration: 5000,
                });
                // setMeta(updatedMeta);

                // formMeta.setFieldsValue({
                //     ...updatedMeta,
                // });
                handleCancel();
            }
            setIsLoadingModal(false);
        } catch (err: any) {
            EmitError(err, true);
            setIsLoadingModal(false);
        }
    }, []);

    const getMetaByUuid = useCallback((uuid: string) => {
        const buscaDeDados = async () => {
            try {
                setIsLoadingModal(true);

                const meta = await PlanoGovernoService.getDetalhesMetaByUuid(uuid, controller.signal);

                let dtPrevistaConclusao = null
                if (meta?.dataPrevistaConclusao) {
                    onDefaultValueDatePicker(new Date(meta.dataPrevistaConclusao))
                    dtPrevistaConclusao = dayjs(meta.dataPrevistaConclusao);
                }


                formMeta.setFieldsValue({
                    ...meta,
                    dataPrevistaConclusao: dtPrevistaConclusao,
                    valorEstimado: validaDigitaçãoEFormataDinheiroBR(meta.valorEstimado),
                    valorGasto: validaDigitaçãoEFormataDinheiroBR(meta.valorGasto),
                });

                setPrioridadeSelecionada(meta.prioridade);
                setStatusSelecionado(meta.status);
                setInputSliderValue(meta.porcentagemConclusao);

                // setMeta(meta);
                setIsLoadingModal(false);
            } catch (error) {
                EmitError(error, true, "useEffect");
                setIsLoadingModal(false);
            }
        };
        return buscaDeDados();
    }, []);


    useEffect((): void => {
        if (isModalOpen && !metaUuid) {
            setPrioridadeSelecionada("Normal");
            setStatusSelecionado(EMetaStatus.PENDENTE);
            setInputSliderValue(0);
            formMeta.resetFields();
            return;
        }

        if (metaUuid) {
            getMetaByUuid(metaUuid);
            return;
        }

    }, [isModalOpen, metaUuid]);

    return {
        prioridadeSelecionada,
        statusSelecionado,
        inputSliderValue,
        onChangeSliderValue,
        handleSetPrioridade,
        handleSetStatus,
        onClickSalvarMeta,
        formMeta,
        refFormMeta,
        isLoadingModal,
        visibleDatePicker,
        onVisibleDatePicker,
        defaultValueDatePicker,
    };
}
